// Import model
import { ProjectTaskCondition } from '../models/ProjectTaskCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ProjectTaskIndexedFields } from '../models/ProjectTaskIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ProjectTaskIndexedFieldsSerializer } from './ProjectTaskIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProjectTaskCondition - handles JSON serialization and deserialization with type validation
 */
export class ProjectTaskConditionSerializer {
  /**
   * Deserializes a JSON string into a ProjectTaskCondition instance
   */
  static deserialize(json: string): ProjectTaskCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProjectTaskCondition instance
   */
  static fromObject(obj: any): ProjectTaskCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProjectTaskCondition');
    }


    const instance: ProjectTaskCondition = {
      fieldName: obj['fieldName'] as ProjectTaskIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProjectTaskCondition instances
   */
  static deserializeArray(json: string): ProjectTaskCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProjectTaskCondition instance to a JSON string
   */
  static serialize(instance: ProjectTaskCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProjectTaskCondition instance to a plain object
   */
  static toObject(instance: ProjectTaskCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ProjectTaskCondition instances to a JSON string
   */
  static serializeArray(instances: ProjectTaskCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
